import React, { useRef, useEffect, useState } from "react";
import Select from "react-select";
import { MenuList } from "./divider/MenuList";

const SelectDropdownDynamic = ({
  options,
  selectedOption,
  setSelectedOption,
  name,
  closeSelect,
  isDisable,
  preventKeyboardOpen,
  onSearchChange,
  fetchMoreData,
  fetchPreviousData,
  ...props
}) => {
  const [isClient, setIsClient] = useState(false);
  const dateRangeRef = useRef();
  const menuListRef = useRef(null);

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!isClient) return;

    const handleClickOutside = (event) => {
      if (
        closeSelect &&
        dateRangeRef.current &&
        !dateRangeRef.current.contains(event.target)
      ) {
        closeSelect();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isClient, closeSelect]);

  const setScrollRef = (ref) => {
    menuListRef.current = ref;
  };

  return (
    <div
      ref={dateRangeRef}
      style={{ width: "100%", height: "100%", minWidth: "100%" }}
      className={`${isDisable ? "disable" : ""}`}
    >
      {isClient && (
        <Select
          value={selectedOption}
          {...props}
          onChange={setSelectedOption}
          onInputChange={onSearchChange}
          options={options || []}
          placeholder={`${name}`}
          isClearable
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          isDisabled={isDisable}
          isSearchable={preventKeyboardOpen ? false : true}
          menuPlacement="auto"
          menuShouldScrollIntoView={false}
          components={{
            MenuList: (props) => (
              <MenuList
                {...props}
                ref={menuListRef}
                setScrollRef={setScrollRef}
                fetchMoreData={fetchMoreData}
                fetchPreviousData={fetchPreviousData}
              />
            ),
          }}
        />
      )}
    </div>
  );
};

export default SelectDropdownDynamic;
